export const pallete ={
    UltraGreen: "#76c64b",
    White:"#ffffff",
    BackGround: "#1b1b1b",
    LightGray: "#ccc",
    UltraGreenFilter: "invert(65%) sepia(66%) saturate(383%) hue-rotate(55deg) brightness(93%) contrast(92%)",
    Black: "black",
}

